<template>
  <SportDiscoverTeamsOrganize sport="tennis" />
</template>

<script>
import SportDiscoverTeamsOrganize from "@/routes/match_hub/shared/SportDiscoverTeamsOrganize.vue";
export default { name: "TennisOrganizeMatch", components: { SportDiscoverTeamsOrganize } };
</script>
